import { render, staticRenderFns } from "./Arcade.vue?vue&type=template&id=b4018516&scoped=true&"
import script from "./Arcade.vue?vue&type=script&lang=js&"
export * from "./Arcade.vue?vue&type=script&lang=js&"
import style0 from "./Arcade.vue?vue&type=style&index=0&id=b4018516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4018516",
  null
  
)

export default component.exports